import React from "react";
import { useTranslation } from "react-i18next";

import TitleFragmentImage from "./TitleFragmentImage";
import MissionData from "./data/MissionData";
import VissionData from "./data/VissionData";

import mission from "./images/landing/mission.webp";
import vission from "./images/landing/vission.webp";
import check from "./images/landing/check.webp";

import "./styles/mv.css";

function MissionVission() {
    const { t } = useTranslation();
    return (
        <section className="mv">
            <TitleFragmentImage title={t('mission.titleFragment')} />

            <div className="mv_main">
                <img className="mv_main_img" src={mission} alt="mission" />
                <div className="mv_main_info">
                    <div className="mv_main_info_title">{t('mission.ourMission')}</div>
                    <div className="mv_main_info_para">{t('mission.missionPara')}</div>
                    <div className="mv_main_info_divider"></div>
                    <div className="mv_main_info_points">
                        {MissionData.map((point, index) => (
                            <div key={index} className="mv_main_info_points_point">
                                <img className="mv_main_info_check" src={check} alt="check" />
                                <div className="mv_main_info_points_point_line">{point.text}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mv_main mv_main_vision">
                <div className="mv_main_info">
                    <div className="mv_main_info_title">{t('mission.ourVision')}</div>
                    <div className="mv_main_info_para">{t('mission.visionPara')}</div>
                    <div className="mv_main_info_divider"></div>
                    <div className="mv_main_info_points">
                        {VissionData.map((point, index) => (
                            <div key={index} className="mv_main_info_points_point">
                                <img className="mv_main_info_check" src={check} alt="check" />
                                <div className="mv_main_info_points_point_line">{point.text}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <img className="mv_main_img" src={vission} alt="vision" />
            </div>
        </section>
    )
}

export default MissionVission;